import { FC, useRef, useState } from "react";
import DropdownMenuProps from "./DropdownMenu.interface";

import styles from "./DropdownMenu.module.css";
import cn from "classnames";
import Icon from "../Icon";
import { useClickOutside } from "../../hooks/useClickOutside";

const DropdownMenu: FC<DropdownMenuProps> = ({
  items
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownMenuRef = useRef<HTMLDivElement>(null);

  useClickOutside(dropdownMenuRef, () => {
    setIsMenuOpen(false);
  });

  return (
    <div className={styles['dropdown-menu__buttons-edit']} ref={dropdownMenuRef}>
      <button
        className={cn(
          styles['dropdown-menu__button-edit'],
          { [styles['dropdown-menu__button-edit_active']]: isMenuOpen }
        )}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className={styles['dropdown-menu__button-edit-dot']} />
        <div className={styles['dropdown-menu__button-edit-dot']} />
        <div className={styles['dropdown-menu__button-edit-dot']} />
      </button>

      {isMenuOpen && (
        <div className={styles["dropdown"]}>
          {items.map(({
            label,
            iconName,
            className,
            action,
            iconClassName,
            ...buttonProps
          }, index) => (
            <button
              key={index}
              className={cn(
                styles.dropdown__item,
                { [styles["dropdown__item_disable"]]: buttonProps.disabled },
                className
              )}
              onClick={action}
              {...buttonProps}
            >
              <div
                className={cn(
                  styles["dropdown__item-icon"],
                  iconClassName
                )}
              >
                <Icon name={iconName} />
              </div>

              <p className={styles["dropdown__item-text"]}>{label}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;